module.exports = __webpack_public_path__ + "img/menu_3.971b3d4e.png";